export const OPTION_DEFAULT_CODE_BY_GEKA = [
  {
    name: 'KIT11VIDACCE',
    terrasse: '0110-00325',
    pergola: '0110-00326',
    toitureVege: '0200-00134',
    bardage: '0110-00302',
  },
  {
    name: 'KIT15VIDACCE',
    terrasse: '0110-00324',
    pergola: '0110-00327	',
    toitureVege: '0200-00136',
    bardage: '0110-00303',
  },
  {
    name: 'KIT20VIDACCE',
    terrasse: '0110-00331',
    pergola: '0110-00332',
    toitureVege: '0200-00138',
    bardage: '0110-00305',
  },
  {
    name: 'KIT26VIDACCE',
    terrasse: '0110-00329',
    pergola: '0110-00328',
    toitureVege: '0200-00137',
    bardage: '0110-00304',
  },
  {
    name: 'KIT30VIDACCE',
    terrasse: '0110-00330',
    pergola: '0110-00333',
    toitureVege: '0200-00139',
    bardage: '0110-00306',
  },
  {
    name: 'KIT41VIDACCE',
    terrasse: '0110-00334',
    pergola: '0110-00335',
    toitureVege: '0200-00143',
    bardage: '0110-00317',
  },
  {
    name: 'KIT50VIDACCE',
    terrasse: '0110-00336',
    pergola: '0110-00337',
    toitureVege: '0200-00144',
    bardage: '0110-00318',
  },
];

export default OPTION_DEFAULT_CODE_BY_GEKA;
